import {
    take,
    fork,
    call,
    put,
    select,
} from 'redux-saga/effects';

import { apiPost } from './callApi';

import actionTypes from '../actionTypes';
import { getToken } from '../selectors';

import apiRoutes from '../../constants/apiRoutes';
import { failOptMission } from "../actionCreators/opt";
import { requestProgressiveMissions } from "../actionCreators/progressiveMissions";
import { requestGameBoxMission } from "../actionCreators/gameBoxMission";

function* optRequest(data: { missionId: number }): any {
    try {
        const headers = {};
        const params = {};
        const { missionId } = data;

        const token = yield select(getToken);

        if (token) {
            params['token'] = token;
            headers['x-access-token'] = JSON.stringify(token);
        }

        if (missionId) {
            params['missionId'] = missionId;
        }

        const response = yield call(apiPost, 'REACT_APP_GAMEBOX_URL', apiRoutes.OPT_TO_MISSION, params, headers);
        if (response?.data?.success) {
            yield put(requestProgressiveMissions());
            yield put(requestGameBoxMission());
        }
    } catch (e) {
        yield put(failOptMission(e));
    }
}

export default function* watchOptMissionRequest(): any {
    while (true) {
        const action = yield take(actionTypes.OPT_TO_MISSION_REQUEST);
        yield fork(optRequest, action);
    }
}
